import React from 'react';
import Resultsection from '../components/Result/resultsection';
import JoinCourseForm from '../components/JoinCourseForm';
import UniqueBanner from "../components/UniqueBanner";
import BannerImg from "../assets/Results-Banner.jpg";


const NttCourse = () => {
  return (
    <>
    <UniqueBanner
  image={BannerImg}
  title="Training Courses for Teachers"
  subtitle="Access student results quickly and easily online"
/>
<Resultsection />
<JoinCourseForm />
    </>
  );
};

export default NttCourse;
